import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./auth/msalConfig"; // Import MSAL config
import "./index.css"; // Ensure Tailwind styles are imported
import App from "./App";
import { ThemeProvider } from "next-themes"; // Import ThemeProvider
import axios from "axios";

// Configure API URL based on environment
const API_URL = process.env.REACT_APP_API_URL || "https://isco-backend-deployment-932661235642.us-central1.run.app";
console.log("API_URL configured:", API_URL);
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post["Content-Type"] = "application/json";

// Add an interceptor to ensure proper protocol
axios.interceptors.request.use((config) => {
  // For local development, ensure http:// protocol
  // No need to modify URLs as they should already have proper protocol
  return config;
});

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL and handle any redirect response before React renders
msalInstance.initialize().then(() => {
  console.log("MSAL initialized successfully");
  
  // Handle redirect response if present (in case popup fallback to redirect)
  msalInstance.handleRedirectPromise().then((response) => {
    if (response) {
      console.log("Redirect response handled:", response);
      msalInstance.setActiveAccount(response.account);
      // Clear the hash to prevent issues with hash router
      if (window.location.hash && window.location.hash.includes('code=')) {
        window.location.hash = '';
      }
    }
  }).catch((error) => {
    console.error("Error handling redirect:", error);
    // If there's an error with the hash, clear it and reload
    if (error.errorCode === "hash_does_not_contain_known_properties") {
      console.log("Clearing corrupted hash and reloading");
      window.location.hash = '';
      window.location.reload();
    }
  });
}).catch((error) => {
  console.error("MSAL initialization error:", error);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* Wrap with MsalProvider */}
    <MsalProvider instance={msalInstance}>
      <HashRouter>
        <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
          <App />
        </ThemeProvider>
      </HashRouter>
    </MsalProvider>
  </React.StrictMode>,
);


// Removed: reportWebVitals(); // REMOVED
